export const CASUAL_PAGE_CONFIG = {
  "title": "Monthly-IAA Game",
  "titleCN": "月报-休闲游戏",
  "path": "/overview/monthly",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "isHaveNotification": true,
      "notificationPath": "/overview/monthly",
      "path": "/overview/monthly",
      "logConfig": {
        "pageId": "200302",
        "pageName": "Monthly-IAA Game",
        "extInfo": "overviewMonthly-IAA",
        "pagePath": "/overview/monthly"
      },
      "filters": [
        {
          "name": "PcConsoleMonthlyFilter",
          "className": "",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/monthly",
          "extraFilterList": [
            "ad_format"
          ],
          "componentList": [
            {
              "name": "MetricInfo",
              "data": {
                "by_tab": "month_aggs"
              },
              "children": [
                {
                  "name": "SegmentCo",
                  "className": "segment-light margin-t-20",
                  "props": {
                    "config": {
                      "dataKey": "by_tab",
                      "options": [
                        {
                          "name": "Monthly Aggregations",
                          "nameCn": "月聚合",
                          "value": "month_aggs",
                          "info": {
                            "textEn": "Daily data aggregated monthly by metric type (Sum, Avg, or Weighted).",
                            "textCn": "基于自然月每日数据根据指标特性进行聚合计算（求和、均值或加权）"
                          }
                        }
                      ]
                    }
                  },
                  "children": [
                    {
                      "id": "month_aggs",
                      "name": "LifetimeCardContainer",
                      "children": [
                        {
                          "name": "KeyMetricTitle",
                          "style": {
                            "marginTop": "-10px"
                          }
                        },
                        {
                          "name": "PlatformMetricsCo",
                          "className": "margin-t-10",
                          "type": "view",
                          "props": {
                            "customRender": true,
                            "dataKey": "iaaRevenueDimensionData",
                            "config": {
                              "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                              "metricsList": [
                                "iaa_revenue"
                              ],
                              "serviceParams": {
                                "breakdown_dimension": "ad_format",
                                "logical_flag": "top_no_others,weighted_daily_average"
                              },
                              "otherParams": "function (data) {\n  var existingCustomFilters = (data && data.custom_filters) || [];\n  var adFormatFilter = existingCustomFilters.find(function (item) {\n    return item.key === 'ad_format';\n  });\n\n  if (adFormatFilter) {\n    adFormatFilter.filter_list = ['interstitial', 'banner', 'rewarded'];\n  } else {\n    existingCustomFilters.push({\n      key: 'ad_format',\n      filter_list: ['interstitial', 'banner', 'rewarded']\n    });\n  }\n\n  return {\n    filters: Object.assign({}, data, {\n      custom_filters: existingCustomFilters\n    })\n  };\n}"
                            }
                          },
                          "children": [
                            {
                              "name": "PlatformMetricsCo",
                              "className": "margin-t-10",
                              "type": "view",
                              "props": {
                                "customRender": true,
                                "dataKey": "impressionDimensionData",
                                "config": {
                                  "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                  "metricsList": [
                                    "imps_per_dau"
                                  ],
                                  "serviceParams": {
                                    "breakdown_dimension": "ad_format",
                                    "logical_flag": "top_no_others,weighted_daily_average"
                                  },
                                  "otherParams": "function (data) {\n  var existingCustomFilters = (data && data.custom_filters) || [];\n  var adFormatFilter = existingCustomFilters.find(function (item) {\n    return item.key === 'ad_format';\n  });\n\n  if (adFormatFilter) {\n    adFormatFilter.filter_list = ['interstitial', 'banner', 'rewarded'];\n  } else {\n    existingCustomFilters.push({\n      key: 'ad_format',\n      filter_list: ['interstitial', 'banner', 'rewarded']\n    });\n  }\n\n  return {\n    filters: Object.assign({}, data, {\n      custom_filters: existingCustomFilters\n    })\n  };\n}"
                                }
                              },
                              "children": [
                                {
                                  "name": "PlatformMetricsCo",
                                  "className": "margin-t-10",
                                  "type": "view",
                                  "props": {
                                    "customRender": true,
                                    "dataKey": "ecpmDimensionData",
                                    "config": {
                                      "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                      "metricsList": [
                                        "ecpm"
                                      ],
                                      "serviceParams": {
                                        "breakdown_dimension": "ad_format",
                                        "logical_flag": "top_no_others,weighted_daily_average"
                                      },
                                      "otherParams": "function (data) {\n  var existingCustomFilters = (data && data.custom_filters) || [];\n  var adFormatFilter = existingCustomFilters.find(function (item) {\n    return item.key === 'ad_format';\n  });\n\n  if (adFormatFilter) {\n    adFormatFilter.filter_list = ['interstitial', 'banner', 'rewarded'];\n  } else {\n    existingCustomFilters.push({\n      key: 'ad_format',\n      filter_list: ['interstitial', 'banner', 'rewarded']\n    });\n  }\n\n  return {\n    filters: Object.assign({}, data, {\n      custom_filters: existingCustomFilters\n    })\n  };\n}"
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "ServiceSelectorFormat",
                                      "props": {
                                        "fieldMappings": [
                                          {
                                            "filterPath": "custom_filters.ua_network",
                                            "selectorPath": "ua_network",
                                            "cascadeConfig": {
                                              "typeField": "type",
                                              "typeValue": "UA",
                                              "codeField": "code",
                                              "filterByType": true
                                            }
                                          }
                                        ]
                                      },
                                      "children": [
                                        {
                                          "name": "Service",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                            "trackData": [
                                              "extraParams",
                                              "gameCode",
                                              "formattedFilter",
                                              "is_confirm"
                                            ],
                                            "extraParams": {
                                              "logical_flag": "weighted_daily_average"
                                            },
                                            "dataKey": "cvrKeyMetricsData",
                                            "beforeRequest": "function(data) {\n                                                                                            var gameCode = data.gameCode, formattedFilter = data.formattedFilter, filterVal = data.filterVal, is_confirm = data.is_confirm;\n                                                                                            var rangeTime = filterVal.rangeTime;\n                                                                                            return {\n                                                                                                game_code: gameCode,\n                                                                                                filters: formattedFilter,\n                                                                                                metrics: [\n                                                                                                    \"ug_cvr\",\n                                                                                                    \"ug_new_cvr\"\n                                                                                                ],\n                                                                                                start_time: rangeTime[0],\n                                                                                                end_time: rangeTime[1],\n                                                                                                period: \"monthly\",\n                                                                                                is_confirm: is_confirm,\n                                                                                                logical_flag: \"weighted_daily_average\"\n                                                                                            };\n                                                                                        }"
                                          },
                                          "children": [
                                            {
                                              "name": "KeyMetricsCo",
                                              "className": "dbd-daily-card",
                                              "type": "view",
                                              "props": {
                                                "config": {
                                                  "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                                  "haveJump": true,
                                                  "loadingHeight": 570,
                                                  "otherParams": {
                                                    "logical_flag": "weighted_daily_average"
                                                  },
                                                  "mainMetricsList": [
                                                    "iaa_revenue",
                                                    "ecpm",
                                                    "arpu",
                                                    "avg_dau",
                                                    "d2t1",
                                                    "d7t6",
                                                    "fraud_active_users_rate",
                                                    "spend",
                                                    "new_users",
                                                    "cpi",
                                                    "af_cpi",
                                                    "roas1",
                                                    "ug_cost_ecpm",
                                                    "ug_ctr"
                                                  ],
                                                  "metricsList": [
                                                    "iaa_revenue",
                                                    "ecpm",
                                                    "arpu",
                                                    "avg_dau",
                                                    "d2t1",
                                                    "d7t6",
                                                    "fraud_active_users_rate",
                                                    "spend",
                                                    "new_users",
                                                    "cpi",
                                                    "af_cpi",
                                                    "roas1",
                                                    "ug_cost_ecpm",
                                                    "ug_ctr"
                                                  ],
                                                  "formatRules": [
                                                    {
                                                      "keys": [
                                                        "trend_list.metrics.arpu.value",
                                                        "trend_list.metrics.arpu.last_value"
                                                      ],
                                                      "format": "twoDecimal"
                                                    }
                                                  ]
                                                }
                                              },
                                              "children": [
                                                {
                                                  "name": "CommonRow",
                                                  "children": [
                                                    {
                                                      "name": "CommonCol",
                                                      "className": "dbd-daily-casual-card-wrap",
                                                      "type": "layout",
                                                      "style": {},
                                                      "props": {
                                                        "w": 8
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "IAARevenueMetricCard",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "style": {
                                                                "minHeight": "232px"
                                                              },
                                                              "config": {
                                                                "jumpUrl": "none",
                                                                "haveTrendChart": false,
                                                                "gradientStartColor": "#009DFF",
                                                                "gradientEndColor": "#1BBFF5",
                                                                "className": "dbd-daily-metric-card-flat-start dbd-daily-casual-color-card dbd-daily-metric-card-flat"
                                                              }
                                                            }
                                                          }
                                                        },
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "CasualMultiViewDimensionCard",
                                                          "height": 142,
                                                          "config": {
                                                            "props": {
                                                              "height": 150,
                                                              "changeHeight": 141
                                                            }
                                                          }
                                                        },
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "ecpmMetricCard",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "style": {
                                                                "minHeight": "232px"
                                                              },
                                                              "config": {
                                                                "isLeftCard": true,
                                                                "isShowIcon": false,
                                                                "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                              }
                                                            }
                                                          }
                                                        },
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "arpuMetricCard",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "style": {
                                                                "minHeight": "232px"
                                                              },
                                                              "config": {
                                                                "jumpUrl": "none",
                                                                "isLeftCard": true,
                                                                "isShowIcon": false,
                                                                "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat-end"
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    },
                                                    {
                                                      "name": "CommonCol",
                                                      "className": "dbd-daily-casual-card-wrap",
                                                      "type": "layout",
                                                      "style": {},
                                                      "props": {
                                                        "w": 8
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "AvgActiveUsersMetricCard",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "style": {
                                                                "minHeight": "232px"
                                                              },
                                                              "config": {
                                                                "jumpUrl": "none",
                                                                "haveTrendChart": false,
                                                                "gradientStartColor": "#8675ff",
                                                                "gradientEndColor": "#a594ff",
                                                                "className": "dbd-daily-metric-card-flat-start dbd-daily-casual-color-card dbd-daily-metric-card-flat"
                                                              }
                                                            }
                                                          }
                                                        },
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "d2t1MetricCard",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "style": {
                                                                "minHeight": "232px"
                                                              },
                                                              "config": {
                                                                "isShowIcon": false,
                                                                "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                              }
                                                            }
                                                          }
                                                        },
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "d7t6MetricCard",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "style": {
                                                                "minHeight": "232px"
                                                              },
                                                              "config": {
                                                                "isShowIcon": false,
                                                                "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                              }
                                                            }
                                                          }
                                                        },
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "FakeDAURateMetricCard",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "style": {
                                                                "minHeight": "232px"
                                                              },
                                                              "config": {
                                                                "jumpUrl": "none",
                                                                "isShowIcon": false,
                                                                "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat-end"
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    },
                                                    {
                                                      "name": "CommonCol",
                                                      "className": "dbd-daily-casual-card-wrap",
                                                      "type": "layout",
                                                      "style": {},
                                                      "props": {
                                                        "w": 8
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "spendMetricCard",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "style": {
                                                                "minHeight": "232px"
                                                              },
                                                              "config": {
                                                                "isRightCard": true,
                                                                "jumpUrl": "none",
                                                                "haveTrendChart": false,
                                                                "gradientStartColor": "#5086F3",
                                                                "gradientEndColor": "#84ADFF",
                                                                "className": "dbd-daily-metric-card-flat-start dbd-daily-casual-color-card dbd-daily-metric-card-flat"
                                                              }
                                                            }
                                                          }
                                                        },
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "NewUsersMetricCard",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "style": {
                                                                "minHeight": "232px"
                                                              },
                                                              "config": {
                                                                "jumpUrl": "none",
                                                                "isShowIcon": false,
                                                                "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                              }
                                                            }
                                                          }
                                                        },
                                                        {
                                                          "name": "CommonRow",
                                                          "style": {
                                                            "marginTop": "-10px"
                                                          },
                                                          "children": [
                                                            {
                                                              "name": "CommonCol",
                                                              "className": "dbd-daily-casual-card-wrap-flex-none-pad-right",
                                                              "children": [
                                                                {
                                                                  "name": "MetricComponent",
                                                                  "path": "overview/monthly",
                                                                  "componentKey": "cpiMetricCard",
                                                                  "height": 150,
                                                                  "config": {
                                                                    "props": {
                                                                      "config": {
                                                                        "style": {
                                                                          "minHeight": "135px"
                                                                        },
                                                                        "jumpUrl": "none",
                                                                        "isShowIcon": false,
                                                                        "haveTrendChart": false,
                                                                        "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat",
                                                                        "subMetricConfig": {
                                                                          "metricKey": "af_cpi",
                                                                          "enName": "{{metricsInfo.af_cpi.en}}",
                                                                          "cnName": "{{metricsInfo.af_cpi.cn}}",
                                                                          "explainEn": "{{metricsInfo.af_cpi.explainEn}}",
                                                                          "explainCn": "{{metricsInfo.af_cpi.explainCn}}",
                                                                          "formatRule": "{{metricsInfo.af_cpi.formatter}}"
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              ]
                                                            },
                                                            {
                                                              "name": "CommonCol",
                                                              "className": "dbd-daily-casual-card-wrap-flex-none-pad-left",
                                                              "children": [
                                                                {
                                                                  "name": "MetricComponent",
                                                                  "path": "overview/monthly",
                                                                  "componentKey": "roas1MetricCard",
                                                                  "height": 150,
                                                                  "config": {
                                                                    "props": {
                                                                      "config": {
                                                                        "style": {
                                                                          "minHeight": "135px"
                                                                        },
                                                                        "jumpUrl": "none",
                                                                        "isShowIcon": false,
                                                                        "haveTrendChart": false,
                                                                        "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          ]
                                                        },
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/monthly",
                                                          "componentKey": "CasualSimpleMetricGrid",
                                                          "height": 150,
                                                          "config": {
                                                            "props": {
                                                              "config": {
                                                                "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat-end"
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "name": "EventService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "marginTop": "10px"
                          },
                          "props": {
                            "removeEventNumLimit": true
                          },
                          "children": [
                            {
                              "name": "CommonRow",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {},
                              "children": [
                                {
                                  "name": "CommonCol",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {
                                    "w": 12
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "overview/monthly",
                                      "componentKey": "OverviewMetricsTrendCo",
                                      "height": 467,
                                      "data": {
                                        "trendMetrics": [
                                          "avg_dau",
                                          "new_users",
                                          "d2",
                                          "d3",
                                          "d7",
                                          "d14",
                                          "total_users",
                                          "avg_active_user_matches",
                                          "avg_new_user_matches",
                                          "aot",
                                          "new_aot"
                                        ]
                                      },
                                      "config": {
                                        "props": {
                                          "config": {
                                            "enableFullScreen": true,
                                            "eventTypeMaxCount": 3,
                                            "fullScreenEnhancements": {
                                              "showEventFilter": true,
                                              "showEventWindows": true,
                                              "showSegmentTabsInFullScreen": true,
                                              "excludeEventTypes": ["Holiday"],
                                              "persistEventSetting": true,
                                              "eventBubbleDetailsNav": {
                                                "minCountExclusive": 0,
                                                "path": "eventAnalysis/eventDetails",
                                                "query": {
                                                  "timeType": "Day",
                                                  "dashboardType": "overview"
                                                }
                                              },
                                              "eventTypeBarColorMap": {
                                                "版更": {
                                                  "tagStyleAliases": ["Version"],
                                                  "eventTooltips": "#F19E55"
                                                },
                                                "Version": {
                                                  "eventTooltips": "#F19E55"
                                                },
                                                "玩法": {
                                                  "tagStyleAliases": ["Gameplay"],
                                                  "eventTooltips": "#1DB440"
                                                },
                                                "实验": {
                                                  "tagStyleAliases": [
                                                    "Experiment",
                                                    "A/B Test",
                                                    "AB Test",
                                                    "ABTest"
                                                  ],
                                                  "eventTooltips": "#6E7794"
                                                }
                                              }
                                            },
                                            "renderIndex": 0,
                                            "showVs": false,
                                            "custom_accumulation": [
                                              "ua_network",
                                              "version"
                                            ],
                                            "api": {
                                              "metricsApi": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                              "dimensionApi": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend",
                                              "extraParams": {
                                                "logical_flag": "weighted_daily_average"
                                              }
                                            },
                                            "eventTypesDisplayLast": [
                                              "Holiday"
                                            ]
                                          }
                                        }
                                      }
                                    }
                                  ]
                                },
                                {
                                  "name": "CommonCol",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {
                                    "w": 12
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "overview/monthly",
                                      "componentKey": "OverviewMetricsTrendCo",
                                      "height": 467,
                                      "data": {
                                        "trendMetrics": [
                                          "iaa_revenue",
                                          "register_arpu",
                                          "arpu",
                                          "ecpm",
                                          "ctr",
                                          "spend",
                                          "cpi",
                                          "af_cpi",
                                          "ug_ctr",
                                          "iaa_impressions",
                                          "imps_per_dau",
                                          "iaa_viewers",
                                          "imps_per_viewers",
                                          "roas1",
                                          "roas7",
                                          "roas14",
                                          "roas30"
                                        ]
                                      },
                                      "config": {
                                        "props": {
                                          "config": {
                                            "enableFullScreen": true,
                                            "eventTypeMaxCount": 3,
                                            "fullScreenEnhancements": {
                                              "showEventFilter": true,
                                              "showEventWindows": true,
                                              "showSegmentTabsInFullScreen": true,
                                              "excludeEventTypes": ["Holiday"],
                                              "persistEventSetting": true,
                                              "eventBubbleDetailsNav": {
                                                "minCountExclusive": 0,
                                                "path": "eventAnalysis/eventDetails",
                                                "query": {
                                                  "timeType": "Day",
                                                  "dashboardType": "overview"
                                                }
                                              },
                                              "eventTypeBarColorMap": {
                                                "版更": {
                                                  "tagStyleAliases": ["Version"],
                                                  "eventTooltips": "#F19E55"
                                                },
                                                "Version": {
                                                  "eventTooltips": "#F19E55"
                                                },
                                                "玩法": {
                                                  "tagStyleAliases": ["Gameplay"],
                                                  "eventTooltips": "#1DB440"
                                                },
                                                "实验": {
                                                  "tagStyleAliases": [
                                                    "Experiment",
                                                    "A/B Test",
                                                    "AB Test",
                                                    "ABTest"
                                                  ],
                                                  "eventTooltips": "#6E7794"
                                                }
                                              }
                                            },
                                            "renderIndex": 1,
                                            "showVs": false,
                                            "custom_accumulation": [
                                              "ua_network",
                                              "version"
                                            ],
                                            "api": {
                                              "metricsApi": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                              "dimensionApi": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend",
                                              "extraParams": {
                                                "logical_flag": "weighted_daily_average"
                                              }
                                            },
                                            "eventTypesDisplayLast": [
                                              "Holiday"
                                            ],
                                            "formatRules": [
                                              {
                                                "keys": [
                                                  "metrics.register_arpu.value",
                                                  "metrics.register_arpu.last_value",
                                                  "metrics.register_arpu.last_avg_value"
                                                ],
                                                "format": "twoDecimal"
                                              },
                                              {
                                                "keys": [
                                                  "metrics.arpu.value",
                                                  "metrics.arpu.last_value",
                                                  "metrics.arpu.last_avg_value"
                                                ],
                                                "format": "twoDecimal"
                                              }
                                            ]
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "name": "MetricComponent",
                          "path": "overview/monthly",
                          "componentKey": "OverviewTableCo",
                          "height": 775,
                          "data": {
                            "tableMetric": [
                              "total_users",
                              "new_users",
                              "avg_dau",
                              "iaa_revenue",
                              "ecpm",
                              "cpi",
                              "af_new",
                              "af_cpi",
                              "new_ch_organic_rate",
                              "fraud_active_users_rate",
                              "spend",
                              "roi",
                              "register_arpu",
                              "arpu",
                              "d2",
                              "d3",
                              "d4",
                              "d5",
                              "d6",
                              "d7",
                              "d14",
                              "d30",
                              "roas1",
                              "roas2",
                              "roas3",
                              "roas7",
                              "roas14",
                              "roas30",
                              "roas60",
                              "roas90",
                              "roas120",
                              "roas180",
                              "iaa_impressions",
                              "avg_active_user_matches",
                              "avg_new_user_matches",
                              "aot",
                              "new_aot",
                              "first_login_ratio",
                              "second_login_ratio"
                            ]
                          },
                          "config": {
                            "props": {
                              "config": {
                                "serviceParams": {
                                  "logical_flag": "weighted_daily_average"
                                }
                              }
                            }
                          }
                        },
                        {
                          "name": "CommonRow",
                          "type": "layout",
                          "className": "margin-t-10",
                          "children": [
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "UserCompositionCo",
                                  "className": "",
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                      "hasByType": false,
                                      "extraParams": {
                                        "metrics": [
                                          "roas1",
                                          "roas3",
                                          "roas7",
                                          "roas14"
                                        ],
                                        "logical_flag": "weighted_daily_average"
                                      }
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "overview/monthly",
                                      "componentKey": "RoasMetricsUserCompositionCo",
                                      "height": 366,
                                      "config": {
                                        "props": {
                                          "config": {
                                            "showComList": [
                                              "eyes",
                                              "lineChart",
                                              "sheet"
                                            ],
                                            "initChartIndex": 1
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "UserCompositionCo",
                                  "className": "",
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                      "hasByType": false,
                                      "extraParams": {
                                        "metrics": [
                                          "register_arpu",
                                          "cpi"
                                        ],
                                        "logical_flag": "weighted_daily_average"
                                      },
                                      "formatRules": [
                                        {
                                          "keys": [
                                            "metrics.register_arpu.value"
                                          ],
                                          "format": "twoDecimal"
                                        }
                                      ]
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "overview/monthly",
                                      "componentKey": "NewUsersArpuCpiMetricsUserCompositionCo",
                                      "height": 366,
                                      "config": {
                                        "props": {
                                          "config": {
                                            "showComList": [
                                              "eyes",
                                              "lineChart",
                                              "sheet"
                                            ],
                                            "initChartIndex": 1
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "UserCompositionCo",
                                  "className": "",
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                      "hasByType": false,
                                      "extraParams": {
                                        "metrics": [
                                          "d2",
                                          "d3",
                                          "d7",
                                          "d14"
                                        ],
                                        "logical_flag": "weighted_daily_average"
                                      }
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "overview/monthly",
                                      "componentKey": "RetentionMetricsUserCompositionCo",
                                      "height": 366,
                                      "config": {
                                        "props": {
                                          "config": {
                                            "showComList": [
                                              "eyes",
                                              "lineChart",
                                              "sheet"
                                            ],
                                            "initChartIndex": 1
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "UserCompositionCo",
                                  "className": "",
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                      "hasByType": false,
                                      "extraParams": {
                                        "metrics": [
                                          "fraud_active_users_rate",
                                          "fraud_active_users"
                                        ],
                                        "logical_flag": "weighted_daily_average"
                                      }
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "overview/monthly",
                                      "componentKey": "FakeDAUMetricsUserCompositionCo",
                                      "height": 366,
                                      "config": {
                                        "props": {
                                          "config": {
                                            "showComList": [
                                              "eyes",
                                              "barChart",
                                              "sheet"
                                            ],
                                            "initChartIndex": 1
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "UserCompositionCo",
                                  "className": "",
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "api": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend",
                                      "hasByType": false,
                                      "extraParams": "function(data) {\n                                                                var segmentValue = (data === null || data === void 0 ? void 0 : data.segmentValue) || 'network_type';\n                                                                if (segmentValue === 'network_type') {\n                                                                    return {\n                                                                        metric: 'new_users',\n                                                                        logical_flag: 'show_all_data,weighted_daily_average',\n                                                                        accumulation: {\n                                                                            custom_accumulation: [\n                                                                                {\n                                                                                    key: 'network_type',\n                                                                                    is_accumulation: true\n                                                                                }\n                                                                            ]\n                                                                        }\n                                                                    };\n                                                                }\n                                                                // ua_network 模式\n                                                                return {\n                                                                    metric: 'new_users',\n                                                                    logical_flag: 'show_all_data,weighted_daily_average',\n                                                                    accumulation: {\n                                                                        custom_accumulation: [\n                                                                            {\n                                                                                key: 'ua_network',\n                                                                                is_accumulation: true\n                                                                            }\n                                                                        ]\n                                                                    }\n                                                                };\n                                                            }",
                                      "formatData": "function(data, extraData) {\n                                                                if (!data) return;\n                                                                var grouped = {};\n                                                                data.forEach(function(item) {\n                                                                    var date = item.date;\n                                                                    var network = item.custom_dimensions && item.custom_dimensions[0] && item.custom_dimensions[0].value;\n                                                                    var newUsers = item.metrics && item.metrics.new_users && item.metrics.new_users.value;\n                                                                    if (!date || !network) return;\n                                                                    if (!grouped[date]) {\n                                                                        grouped[date] = {\n                                                                            date: date,\n                                                                            metrics: {}\n                                                                        };\n                                                                    }\n                                                                    grouped[date].metrics[network] = {\n                                                                        value: newUsers || '',\n                                                                        last_value: '',\n                                                                        last_avg_value: '',\n                                                                        last_month_value: '',\n                                                                        last_year_value: ''\n                                                                    };\n                                                                });\n                                                                var result = Object.values(grouped).sort(function(a, b) {\n                                                                    return a.date.localeCompare(b.date);\n                                                                });\n                                                                return result;\n                                                            }"
                                    }
                                  },
                                  "data": {
                                    "key": "network_type",
                                    "segmentValue": "network_type"
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "overview/monthly",
                                      "componentKey": "NewUserBreakdownMetricsUserCompositionCo",
                                      "height": 366,
                                      "style": {
                                        "height": 366
                                      },
                                      "config": {
                                        "props": {
                                          "config": {
                                            "showComList": [
                                              "eyes",
                                              "barChart",
                                              "stackLine",
                                              "sheet"
                                            ],
                                            "initChartIndex": 2,
                                            "showSum": true
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "UserCompositionCo",
                                  "className": "",
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                      "hasByType": false,
                                      "extraParams": {
                                        "metrics": [
                                          "spend",
                                          "iaa_revenue",
                                          "roi"
                                        ],
                                        "logical_flag": "weighted_daily_average"
                                      }
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "overview/monthly",
                                      "componentKey": "SpendIaaRevenueRoiMetricsUserCompositionCo",
                                      "height": 366,
                                      "config": {
                                        "props": {
                                          "config": {
                                            "showComList": [
                                              "eyes",
                                              "lineChart",
                                              "sheet"
                                            ],
                                            "initChartIndex": 1
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "name": "CommonRow",
                          "type": "layout",
                          "style": {
                            "marginTop": 0
                          },
                          "props": {},
                          "children": [
                            {
                              "name": "RankListTabCo",
                              "className": "",
                              "style": {},
                              "type": "view",
                              "data": {
                                "regionDataType": "country",
                                "tabOrder": [
                                  "country",
                                  "region",
                                  "os",
                                  "ua_network",
                                  "version"
                                ],
                                "tabMsg": {
                                  "os": {
                                    "aliasNameEn": "Platform",
                                    "aliasNameCn": "平台"
                                  },
                                  "country": {
                                    "aliasNameEn": "Countries",
                                    "aliasNameCn": "国家"
                                  },
                                  "region": {
                                    "aliasNameEn": "Regions",
                                    "aliasNameCn": "区域"
                                  },
                                  "ua_network": {
                                    "aliasNameEn": "Media Channels",
                                    "aliasNameCn": "买量渠道"
                                  },
                                  "version": {
                                    "aliasNameEn": "Versions",
                                    "aliasNameCn": "版本"
                                  }
                                },
                                "optionsInit": [
                                  {
                                    "value": "ua_network",
                                    "textEn": "Media Channel",
                                    "textCn": "买量渠道"
                                  },
                                  {
                                    "value": "version",
                                    "textEn": "Version",
                                    "textCn": "版本"
                                  }
                                ]
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "overview/monthly",
                                  "componentKey": "NewUsersMetricsRankListCo",
                                  "height": 533,
                                  "config": {
                                    "props": {
                                      "config": {
                                        "jumpUrl": "none",
                                        "comConfig": {
                                          "isHaveStackLine": true,
                                          "isHaveLine": false
                                        },
                                        "api": "/api/v1/dashboard/pc/overview_daily/breakdown",
                                        "defaultChartType": "stackLine",
                                        "extraParams": {
                                          "logical_flag": "weighted_daily_average"
                                        }
                                      }
                                    }
                                  }
                                },
                                {
                                  "name": "MetricComponent",
                                  "path": "overview/monthly",
                                  "componentKey": "ActiveUsersMetricsRankListCo",
                                  "height": 533,
                                  "config": {
                                    "props": {
                                      "config": {
                                        "jumpUrl": "none",
                                        "defaultChartType": "map",
                                        "api": "/api/v1/dashboard/pc/overview_daily/breakdown",
                                        "extraParams": {
                                          "logical_flag": "weighted_daily_average"
                                        }
                                      }
                                    }
                                  }
                                },
                                {
                                  "name": "MetricComponent",
                                  "path": "overview/monthly",
                                  "componentKey": "IaaRevenueMetricsRankListCo",
                                  "height": 533,
                                  "config": {
                                    "props": {
                                      "config": {
                                        "jumpUrl": "none",
                                        "api": "/api/v1/dashboard/pc/overview_daily/breakdown",
                                        "extraParams": {
                                          "logical_flag": "weighted_daily_average"
                                        }
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "operationList": [
    {
      "nameEn": "情报",
      "nameCn": "Intelligence",
      "url": "function(data) { const { unifiedid } = data; return '/intelligence/topCharts/mobileGames/gamesDetails/' + unifiedid; }"
    },
    {
      "nameEn": "舆情",
      "nameCn": "Opinions",
      "url": "/opinion/Overview/KeyMetrics",
      "params": {
        "gameid": "unifiedid"
      },
      "permission": "hasOpinionPermissions"
    }
  ]
};
